// extracted by mini-css-extract-plugin
export default {"toolbar":"BackgroundToolbar_toolbar__LY4gk","iconContainer":"BackgroundToolbar_iconContainer__BxvAs","unfocused":"BackgroundToolbar_unfocused__1+fdo"};